"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.validateRepoOrImageRef = exports.ValidationError = exports.REPO_IMAGE_REF_BLANK_ERROR = exports.REPO_IMAGE_REF_INVALID_CHARS_ERROR = void 0;
exports.REPO_IMAGE_REF_INVALID_CHARS_ERROR = 'Repository and image reference may not contain & ; " or a space or double slash';
exports.REPO_IMAGE_REF_BLANK_ERROR = "Repository and image reference may not be blank";
class ValidationError extends Error {
}
exports.ValidationError = ValidationError;
function validateRepoOrImageRef(input) {
    const invalidCharacters = ["&", ";", " ", '"'];
    if (!input || input.trim().length === 0) {
        throw new ValidationError(exports.REPO_IMAGE_REF_BLANK_ERROR);
    }
    if (invalidCharacters.some(c => input.includes(c))) {
        throw new ValidationError(exports.REPO_IMAGE_REF_INVALID_CHARS_ERROR);
    }
    if (input.includes("//")) {
        throw new ValidationError(exports.REPO_IMAGE_REF_INVALID_CHARS_ERROR);
    }
}
exports.validateRepoOrImageRef = validateRepoOrImageRef;
//# sourceMappingURL=validation.js.map